<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useAppStore } from '../store'
import RegistrationForm from './RegistrationForm.vue'

/**
 * The way in, the old app's form_Entree: who QuickTide is for, and what it shows for
 * someone who has not registered. The Delphi screen had two buttons and no field; this one
 * keeps the two buttons and opens the e-mail field in place, so registering never means
 * going to look for a settings screen.
 *
 * It is shown once. "Demonstratie" is a real answer, not a postponement -- the app works
 * without registering, for four days at a time -- and the Registratie section in Settings
 * is where anyone who changes their mind goes. A registration that runs out puts the screen
 * back exactly once, with the reason at the top.
 */

const store = useAppStore()
const asking = ref(false)
const showing = computed(() => !store.settings.entrySeen && !store.registered)
const expired = computed(() => store.licence?.reason === 'expired')

function demo() {
  store.settings.entrySeen = true
}

// registering finishes the screen: the link has been followed and the data is on its way
watch(() => store.registered, is => { if (is) store.settings.entrySeen = true })
</script>

<template>
  <div v-if="showing" class="modal">
    <div class="card entry">
      <h1>{{ store.t('welcomeTitle') }}</h1>
      <p v-if="expired" class="notice warn small">{{ store.t('registrationExpired') }}</p>
      <!-- who it is for: as the server says it is open just now, else who it is meant for -->
      <p>{{ store.openTo ? store.tv('entryWhoOpen', store.openTo) : store.t('entryWho') }}</p>
      <p class="muted">{{ store.t('entryDemo') }}</p>

      <template v-if="asking">
        <RegistrationForm />
        <div class="cardbuttons">
          <button class="link" @click="asking = false">{{ store.t('back') }}</button>
          <button class="big" @click="demo()">{{ store.t('demoButton') }}</button>
        </div>
      </template>
      <div v-else class="cardbuttons">
        <button class="big" @click="demo()">{{ store.t('demoButton') }}</button>
        <button class="primary big" @click="asking = true">{{ store.t('registerCta') }}</button>
      </div>
    </div>
  </div>
</template>
